/*
 * Presentation Templates — turns a set of selected slide ids into slides in
 * the deck. Thin wrapper around shared/services/pptxTemplateSlideInsert.ts's
 * `insertTemplateSlides` (source-file grouping, sub-deck building, insert
 * loop — identical to Slide Templates' own need, see that module's header)
 * with this feature's own messages/telemetry reasons.
 */

import { insertTemplateSlides } from "../../shared/services/pptxTemplateSlideInsert";
import { logPresentationTemplatesError, type PresentationTemplateSlide } from "./presentationTemplatesApi";

export const NO_INSERTABLE_SELECTION_MESSAGE = "None of the selected slides have insertable content yet.";
const SOURCE_DOWNLOAD_FAILED_MESSAGE = "Downloading this slide's source file failed.";

/**
 * Inserts the selected slides, in the order `slides` lists them.
 *
 * @returns how many slides were inserted.
 */
export async function insertPresentationTemplates(
  slides: readonly PresentationTemplateSlide[],
  selectedIds: readonly string[],
): Promise<number> {
  return insertTemplateSlides(
    slides,
    selectedIds,
    { noInsertableSelection: NO_INSERTABLE_SELECTION_MESSAGE, sourceDownloadFailed: SOURCE_DOWNLOAD_FAILED_MESSAGE },
    { log: logPresentationTemplatesError, reasonPrefix: "presentation-templates" },
  );
}
